// test981
(981 && 0);
